import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, ShieldAlert, Info, ArrowRight } from "lucide-react";
import { claimsContacts, claimsNote, company } from "../mock";

const Claims = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="relative">
      <section className="relative overflow-hidden">
        <div className="aurora bg-[#8ec4ec] h-80 w-80 -top-20 -left-16" />
        <div className="aurora bg-[#8ec4ec] h-80 w-80 top-0 right-0" />
        <div className="max-w-4xl mx-auto px-6 pt-16 pb-8 text-center relative z-10 fade-up">
          <div className="h-16 w-16 mx-auto rounded-2xl bg-gradient-to-br from-[#0066b3] to-[#003c7a] flex items-center justify-center text-white mb-6 shadow-lg">
            <ShieldAlert size={30} />
          </div>
          <nav className="text-sm text-slate-500 mb-4 flex items-center justify-center gap-2">
            <Link to="/" className="hover:text-[#0066b3]">Home</Link>
            <span>/</span>
            <span className="text-[#0066b3] font-medium">Claims</span>
          </nav>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-[#0a2b52]">
            Insurance <span className="brand-gradient-text">Claims</span>
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl mx-auto">
            {claimsNote}
          </p>
          <a
            href={`tel:${company.phoneRaw}`}
            className="brand-btn inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold mt-7"
          >
            <Phone size={18} /> Call Our Office: {company.phone}
          </a>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pt-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {claimsContacts.map((c, i) => (
            <div
              key={c.insurer}
              className="glass rounded-3xl p-7 card-hover fade-up"
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <h3 className="font-display text-xl font-bold text-[#0a2b52] mb-4 pb-3 border-b border-slate-200/70">
                {c.insurer}
              </h3>
              <ul className="space-y-3">
                {c.lines.map((line) => {
                  const match = line.match(/(\+?[\d][\d\s\-]{6,})/);
                  const tel = match ? match[1].replace(/[^\d+]/g, "") : null;
                  return (
                    <li key={line} className="flex items-start gap-2.5">
                      <Phone size={17} className="text-[#0066b3] shrink-0 mt-0.5" />
                      {tel ? (
                        <a
                          href={`tel:${tel}`}
                          className="text-slate-700 hover:text-[#0066b3] transition-colors text-sm leading-relaxed"
                        >
                          {line}
                        </a>
                      ) : (
                        <span className="text-slate-700 text-sm leading-relaxed">
                          {line}
                        </span>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 pt-12">
        <div className="glass-strong rounded-3xl p-6 md:p-8 border-l-4 border-[#0066b3] flex items-start gap-4">
          <Info size={24} className="text-[#0066b3] shrink-0 mt-0.5" />
          <p className="text-slate-600 leading-relaxed">
            Please ensure you have your policy number available; this can be
            found on your travel card or policy declaration page. For any
            assistance during business hours, contact our office and our team
            will be glad to help.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pt-12">
        <div className="glass-strong rounded-3xl p-10 md:p-12 text-center relative overflow-hidden">
          <div className="aurora bg-[#cfe4f6] h-64 w-64 -bottom-24 -right-10" />
          <h2 className="font-display text-3xl font-extrabold text-[#0a2b52] relative">
            Have questions about your claim?
          </h2>
          <p className="text-slate-600 mt-3 max-w-xl mx-auto relative">
            We're open 7 days a week and happy to walk you through the process.
          </p>
          <Link
            to="/contact"
            className="brand-btn inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold mt-7 relative"
          >
            Contact Us <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Claims;
